import React, { useEffect, useState, useRef } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import SubscriptionService from '../../services/SubscriptionService';

function EditSubscription() {
  const { id } = useParams();
  const toast = useRef(null);
  const [SubscriptionPlans, setSubscriptionPlans] = useState([]);
  const [loadingSubscriptionPlans, setLoadingSubscriptionPlans] = useState(true);
  

  const [form, setForm] = useState({
    subscriptionPlanId:"",
    price:"",
    startDate:"",
    endDate:"",
    isActive: false,
    id: id,
    clientId: "",
  });
  const [formError, setFormError] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      try {
        const subscription = await SubscriptionService.getSubscriptionById(id);
        setForm(subscription);
      } catch (error) {
        console.error('Error fetching subscription details:', error);
      }
    };
    fetchSubscriptionData();
  }, [id]);

   useEffect(() => {
      const fetchSubscriptionPlans = async () => {
        try {
          const subscriptionplans = await SubscriptionService.getAllSubscriptionPlans();
          setSubscriptionPlans(subscriptionplans);
        } catch (error) {
          console.error("Error fetching subscriptionplans:", error);
        } finally {
          setLoadingSubscriptionPlans(false);
        }
      };
      fetchSubscriptionPlans();
    }, []);

  const handleInputChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setForm(prevForm => ({ ...prevForm, [name]: checked }));
    } else if (files) {
      setForm(prevForm => ({ ...prevForm, [name]: files[0] }));
    } else {
      setForm(prevForm => ({ ...prevForm, [name]: value }));
    }
  };

  const validateForm = () => {
    const errors = {};
    Object.keys(form).forEach(key => {
      const value = String(form[key]);
      if (!value.trim() && key !== 'userImage') {
        errors[key] = `Please enter ${key}`;
      }
    });
    setFormError(errors);
    return Object.keys(errors).length === 0;
  };

  const updateSubscription = async () => {
    debugger
    const isValid = validateForm();
    if (!isValid) return;
    
    const formDataToSend = new FormData();
    
    Object.keys(form).forEach(key => {
      if (key === 'userImage' && form[key] instanceof File) {
        formDataToSend.append(key, form[key]);
      } else {
        formDataToSend.append(key, form[key]);
      }
    });
  
    try {
      await SubscriptionService.updateSubscription(id, formDataToSend);

      if (toast.current) {
        toast.current.show({
          severity: 'success',
          summary: 'Success',
          detail: 'Subscription updated successfully',
          className: 'custom-toast-success',
          life: 3000
        });
      }
      setTimeout(() => {
        navigate(-1); // Navigate after toast shows
      }, 1000);
    } catch (error) {
      console.error("Error updating Subscription:", error);
      if (toast.current) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to update user',
          className: 'custom-toast-delete',
          life: 3000
        });

      }
    }
  };
  
  return (
    <div>

      <Toast ref={toast} />
      <div className='form-group row'>
         <div className='col-lg-12 float-end'>
                              <div className='col-lg-3 float-end'>
                              </div> 
                   </div>
      </div>
      <br></br>

        <form onSubmit={e => e.preventDefault()}>

          <div className="form-group row">
          <label className="col-lg-2" htmlFor="subscriptionPlanId">
       Subscription Plan
            </label>
            <div className="col-lg-4">
                <select
          name="subscriptionPlanId"
          id="subscriptionPlanId"
          className="form-control"
          value={form.subscriptionPlanId}
          onChange={handleInputChange}
        >
          <option value=""> Select</option>
          {loadingSubscriptionPlans ? (
            <option>Loading...</option>
          ) : (
            SubscriptionPlans.map((subscriptionPlan) => (
              <option key={subscriptionPlan.id} value={subscriptionPlan.id}>
                {subscriptionPlan.subscriptionPlanName}
              </option>
            ))
          )}
        </select>
                </div>
                <label className="col-lg-2" htmlFor="price">
       Price
            </label>
            <div className="col-lg-3">
          <input
            type="number"
            name="price"
            id="price"
            className="form-control"
            value={form.price}
            onChange={handleInputChange} 
          />
          <p className="text-danger">{formError.price}</p>
          </div>
          </div>
          <div className="form-group row">
          <label className="col-lg-2" htmlFor="startDate">
        Start Date
            </label>
            <div className="col-lg-4">
          <input
            type="datetime-local"
            name="startDate"
            id="startDate"
            className="form-control"
            value={form.startDate}
            onChange={handleInputChange} 
          />
          <p className="text-danger">{formError.startDate}</p>
          </div>
          <label className="col-lg-2" htmlFor="endDate">
        End Date
            </label>
            <div className="col-lg-3">
          <input
            type="datetime-local"
            name="endDate"
            id="endDate"
            className="form-control"
            value={form.endDate}
            onChange={handleInputChange} 
          />
          <p className="text-danger">{formError.endDate}</p>
          </div>
          </div>
          <div className="form-group row">
          <label className="col-lg-2" htmlFor="isActive">
                Is Active?
              </label>
              <div className="col-lg-4">
                  <input
                      type="checkbox"
                      name="isActive"
                      id="isActive"
                      checked={form.isActive}
                      onChange={handleInputChange}
                    />
              <p className="text-danger">{formError.isActive}</p>
            </div>
           
          </div>
          <div className="form-group row">
            <div className="col-md-12 text-center">
              <button type="submit" className="btn btn-save btn-dark text-white" onClick={updateSubscription}>Update</button>
            </div>
          </div>
        </form>
     
    </div>
  );
}

export default EditSubscription;